import React, { useState, useContext } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import axios from 'axios';
import LandingPage from './landing/LandingPage';
import TradingPlatform from './trading/TradingApp';
import AuthModal from './landing/AuthModal';
import './LandingApp.css';

const LandingApp = () => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const { tt } = useLanguage();
  const [authMode, setAuthMode] = useState('login'); // 'login' or 'register'
  const [language, setLanguage] = useState('ru');
  const { user, login, logout, setUser } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  // Если пользователь пытается зайти на CRM страницу без авторизации,
  // сохраняем путь и показываем модальное окно логина
  React.useEffect(() => {
    if (location.pathname.startsWith('/crm') && !user) {
      sessionStorage.setItem('intendedPath', location.pathname);
      setIsAuthModalOpen(true);
      setAuthMode('login');
    }
  }, [location.pathname, user]);

  const openAuthModal = (mode) => {
    setAuthMode(mode);
    setIsAuthModalOpen(true);
  };

  const closeAuthModal = () => {
    setIsAuthModalOpen(false);
  };

  const handleLogin = async (userData, token) => {
    console.log('🎯 LandingApp handleLogin called with:', { userData, token: token ? 'exists' : 'missing' });
    
    // Устанавливаем токен и пользователя
    console.log('💾 LandingApp: Storing token in localStorage...');
    localStorage.setItem('token', token);
    
    console.log('🔧 LandingApp: Setting axios default Authorization header...');
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    
    console.log('👤 LandingApp: Setting user in AuthContext:', userData);
    setUser(userData); // Используем setUser из AuthContext
    
    console.log('❌ LandingApp: Closing auth modal...');
    closeAuthModal();
    
    // Если пользователь - клиент, перенаправляем на торговую платформу
    if (userData.role === 'client') {
      console.log('🚀 LandingApp: User is client, navigating to /trading...');
      navigate('/trading');
    } else {
      // Если пользователь пытался зайти в CRM, перенаправим его туда
      const intendedPath = sessionStorage.getItem('intendedPath');
      if (intendedPath && intendedPath.startsWith('/crm')) {
        sessionStorage.removeItem('intendedPath');
        navigate(intendedPath);
      } else {
        // По умолчанию админов отправляем в CRM
        navigate('/crm/dashboard');
      }
    }
  };

  const handleLogout = () => {
    logout(); // Используем функцию logout из AuthContext
  };

  const switchLanguage = (lang) => {
    setLanguage(lang);
  };

  return (
    <div className="landing-app">
      <Routes>
        {/* Trading Platform - Protected Route */}
        <Route 
          path="/platform" 
          element={
            user ? (
              <TradingPlatform />
            ) : (
              <Navigate to="/" replace />
            )
          } 
        />

        {/* Landing Page - обрабатывает все остальные пути */}
        <Route 
          path="*" 
          element={
            <LandingPage 
              user={user}
              language={language}
              onLogin={() => openAuthModal('login')}
              onRegister={() => openAuthModal('register')}
              onLogout={handleLogout}
              onSwitchLanguage={switchLanguage}
            />
          } 
        />
      </Routes>

      {/* Auth Modal */}
      {isAuthModalOpen && (
        <AuthModal
          mode={authMode}
          onClose={closeAuthModal}
          onLogin={handleLogin}
          onSwitchMode={(mode) => setAuthMode(mode)}
          language={language}
        />
      )}
    </div>
  );
};

export default LandingApp;